import axios from 'axios';
import URL from "./setting.service.js"

axios.defaults.baseURL = process.env.API_HOST;
//全局设置头部信息
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//全局设置超时时间
axios.defaults.timeout = 100000;

axios.defaults.crossDomain = true;
//axios.defaults.withCredentials = true;  //设置cross跨域 并设置访问权限 允许跨域携带cookie信息
axios.defaults.headers.common['Authorization'] = ''; // 设置请求头为 Authorization

export default {
    server_url:URL.server_url,
    // 公众号-根据手机号检测是否存在
    checkPhoneIsExists(from_data) {
        return new Promise((resolve, reject) => {
            axios.post(URL.CommonURL.checkPhoneIsExistsURL, from_data).then(data => {
                resolve(data);
            })
        })
    },
    // 获取字典列表
    getDictDataListByType(from_data) {
        return new Promise((resolve, reject) => {
            axios.post(URL.CommonURL.getDictDataListByTypeURL, from_data).then(data => {
                resolve(data);
            })
        })
    },
    // 公众号-提交审核
    wechatCommitPhoto(from_data) {
        return new Promise((resolve, reject) => {
            axios.post(URL.CommonURL.wechatCommitPhotoURL, from_data).then(data => {
                resolve(data);
            })
        })
    },
    // 数据提交
    tech_www(from_data) {
        return new Promise((resolve, reject) => {
            axios.post(URL.CommonURL.tech_wwwURL, from_data).then(data => {
                resolve(data);
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/service/common.service.js